export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_COUNSELING_HISTORY":
      return [...state, action.payload.counselingHistory];
    case "UPDATE_COUNSELING_HISTORY":
      return action.payload.counselingHistory;
    case "DELETE_COUNSELING_HISTORY":
      return state.filter((counselingHistory) => {
        return counselingHistory.id !== action.payload.counselingHistory.id;
      });
    default:
      return state;
  }
};
